const mobileBreakpoint = window.matchMedia("(max-width: 991px)");

$(document).ready(function () {
    var $body = $("body");
    var $sidebar = $(".dash-nav");
    var $backdrop = $(".sidebar-backdrop");

    // ---- Mobile drawer -------------------------------------------------

    function openDrawer() {
        $sidebar.addClass("mobile-show");
        $backdrop.addClass("is-visible");
        $body.addClass("sidebar-open");
    }

    function closeDrawer() {
        $sidebar.removeClass("mobile-show");
        $backdrop.removeClass("is-visible");
        $body.removeClass("sidebar-open");
    }

    function toggleDrawer() {
        if ($sidebar.hasClass("mobile-show")) {
            closeDrawer();
        } else {
            openDrawer();
        }
    }

    $(".menu-toggle").click(function (e) {
        e.preventDefault();
        if (mobileBreakpoint.matches) {
            toggleDrawer();
        } else {
            // On desktop the hamburger collapses the sidebar out of the way.
            $(".dash").toggleClass("dash-compact");
        }
    });

    $(".dash-nav-close").click(closeDrawer);
    $backdrop.click(closeDrawer);

    // Following a link should dismiss the drawer, otherwise it stays open
    // over the page that just loaded.
    $sidebar.on("click", "a[href]", function () {
        var href = $(this).attr("href");
        if (mobileBreakpoint.matches && href && href !== "#") {
            closeDrawer();
        }
    });

    $(document).on("keydown", function (e) {
        if (e.key === "Escape" || e.keyCode === 27) {
            closeDrawer();
        }
    });

    // Resizing past the breakpoint leaves the drawer state stale.
    function syncToBreakpoint() {
        if (!mobileBreakpoint.matches) {
            closeDrawer();
        }
    }

    if (mobileBreakpoint.addEventListener) {
        mobileBreakpoint.addEventListener("change", syncToBreakpoint);
    } else if (mobileBreakpoint.addListener) {
        mobileBreakpoint.addListener(syncToBreakpoint);
    }

    // ---- Sidebar nav groups --------------------------------------------

    $(".dash-nav-dropdown-toggle").click(function () {
        $(this).closest(".dash-nav-dropdown")
            .toggleClass("show")
            .find(".dash-nav-dropdown")
            .removeClass("show");

        $(this).parent()
            .siblings()
            .removeClass("show");
    });

    // The group holding the current page is rendered with .show already;
    // keep any others collapsed so only one branch is open at a time.
    var $openGroups = $(".dash-nav-dropdown.show");
    if ($openGroups.length > 1) {
        $openGroups.slice(1).removeClass("show");
    }

    // Scroll the active entry into view when the menu is long enough to clip it.
    var activeItem = document.querySelector(".dash-nav .is-active");
    if (activeItem && typeof activeItem.scrollIntoView === "function") {
        activeItem.scrollIntoView({ block: "nearest" });
    }

    $(".searchbox-toggle").click(function () {
        $(".searchbox").toggleClass("show");
    });
});
